export default __webpack_public_path__ + "static/media/logo_pif_suburbia.a5b44a2a.png";